'use strict';

/* Slick Carousel */
import 'slick-carousel';

require('!style-loader!css!slick-carousel/slick/slick.css');

(function ($) {
    $(window).on('load statechangecomplete', function () {
        $('.slick-page-header').slick({
            rows: 0,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 8000,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
        });
    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/slick-carousel.js